import { logError } from '@ecomm/error-handling'
import { COOKIE_LEAD_DATA, setCookie } from '@ecomm/shared-cookies'
import { fbTrackLeadCreated, handleBrazeTrackingEvent } from '@ecomm/tracking'
import type { MaybeT } from '@simplisafe/ewok'
import {
  type LeadGenCaptureParams,
  type LeadGenCaptureResponse,
  leadGenCapture
} from '@simplisafe/ss-ecomm-data/leads/capture'
import { cookiesOption } from '@simplisafe/ss-ecomm-data/simplisafe/yodaClient'

export const handleSuccess = (value: MaybeT<LeadGenCaptureResponse>) => {
  setCookie(COOKIE_LEAD_DATA, value.orUndefined(), cookiesOption)

  handleBrazeTrackingEvent(value.orUndefined())

  value.forEach(
    async response =>
      response.email && (await fbTrackLeadCreated(response.email))
  )
}

export const leadCapture = (email: string) => {
  const leadGenParams: LeadGenCaptureParams = {
    email,
    source: 'purchase',
    sourceType: 'purchase'
  }
  leadGenCapture(leadGenParams)(logError)(handleSuccess)
}
